module.exports = __webpack_public_path__ + "static/Department-Stores-17241ad7311aee56d4747a8bb62ebbf7.jpg";